import focusTrap from 'focus-trap';

class MobileNav {
    constructor() {
        this.mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
        this.nav = document.querySelector('[data-nav]');
        this.header = document.querySelector('[data-header]');

        this.focusTrap = focusTrap(this.header, {
            initialFocus: '.main-nav__link',
        });

        this.isOpen = false;
    }

    init = () => {
        if (this.mobileNavToggle && this.nav && this.header) {
            this.mobileNavToggle.addEventListener('click', this.toggle);
        }
    };

    toggle = () => {
        (this.isOpen ? this.close : this.open)();
    };

    open = () => {
        this.isOpen = true;

        this.focusTrap.activate();

        this.nav.classList.add('is-active');
        this.mobileNavToggle.setAttribute('aria-expanded', 'true');

        this.header.classList.add('is-active');

        document.body.classList.add('disable-scroll');

        setTimeout(() => {
            window.addEventListener('keydown', this.closeOnEscape);
        }, 500);
    };

    close = () => {
        this.isOpen = false;

        this.focusTrap.deactivate();

        this.nav.classList.remove('is-active');
        this.mobileNavToggle.setAttribute('aria-expanded', 'false');

        this.header.classList.remove('is-active');

        document.body.classList.remove('disable-scroll');

        window.removeEventListener('keydown', this.closeOnEscape);
    };

    closeOnEscape = (event) => {
        if (event.keyCode === 27) {
            this.close();
        }
    };
}

export default MobileNav;
